import React from "react";
import LoginLayer from "../components/LoginLayer";
import PublicSEO from "../components/public/PublicSEO";

const LoginPage = () => {
  return (
    <>
      <PublicSEO
        title="Accedi"
        description="Accedi alla tua area riservata Virtual Clinic per gestire appuntamenti, referti e documentazione clinica."
        canonicalPath="/login"
        noIndex
      />
      <LoginLayer />
    </>
  );
};

export default LoginPage;

